module.exports = __webpack_public_path__ + "static/delivery-19f64b70c6f2c5086f5d27ccf2f02472.png";